import type { CombinedError } from '@urql/core'
import type { FC } from 'react'
import { useState } from 'react'

import type { ButtonProps } from '@app/components/ui/button'
import { Button } from '@app/components/ui/button'
import { toaster } from '@app/components/ui/toaster'
import unpackErrors from '@app/utils/unpackErrors'
import { useMapSimulateMutation } from '@graphql/queries'

type Props = ButtonProps & {
  strategyId: string
}

const errorToast = (error: CombinedError) => {
  const unpacked = unpackErrors([error])
  const message = unpacked.global?.message?.replace('[GraphQL] ', '') || 'Unknown error'

  toaster.error({
    title: 'Error running simulation',
    description: message,
    meta: { closable: true }
  })
}

const MapSimulationRun: FC<Props> = ({ strategyId, ...props }) => {
  const [loading, setLoading] = useState(false)
  const [, run] = useMapSimulateMutation()

  const onClick = async () => {
    setLoading(true)
    try {
      const r = await run({ input: { strategyId } })
      if (r.error) {
        errorToast(r.error)
      }
    } catch (e) {
      errorToast(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button loading={loading} onClick={onClick} {...props}>
      Run sim
    </Button>
  )
}

export default MapSimulationRun
